"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReportData = void 0;
/**
 * Get report data as base64 CSV-formatted string using objection-find filters, such as:

Built-in filters `eq`, `neq`, `lt`, `lte`, `gt`, `gte`, `like`, `likeLower`, `in`, `notNull` or `isNull`

Example:
```
  ?vehicle_type:in=maxi,luton,caged&orderBy=date&order=asc
```

Utilises [Objection Find](https://github.com/Vincit/objection-find).

Filtered By companyCode:
```
?companyCode:in=CompanyA,CompanyB
```

Filtered By dateRange:
```
?date:gte=2023-01-01&date:lte=2023-08-14
```
Default Job Report Columns: "jobRef", "companyCode", "invoiceNumber", "invoiceAmount",
"creditAmount", "orderType", "date", "status", "postcode", "weight", "volume", "mattress",
"fridges", "tvMonitor", "smallPops", "largePops", "footstool", "armchair", "sofaTwoSeat",
"sofaThreeSeat", "bed", "sofabed", "cornerSofa", "otherItems"

Filtered By excludedColumns:
```
 ?excludedColumns=jobRef,companyCode,invoiceNumber
```

 */
var getReportData = function (instance) { return function (config) {
    return instance.get("/reports/data/download", config);
}; };
exports.getReportData = getReportData;
